/**
 * Include your custom JavaScript here.
 *
 */

(function(){
  var schedule = [
    { after: 5, stock: 13 },
    { after: 15, stock: 12 },
    { after: 40, stock: 11 },
    { after: 90, stock: 10 },
    { after: 240, stock: 9 }
  ];

  var storageKey = 'professionalMiniCartStockStartedAt';

  function startedAt() {
    var value = sessionStorage.getItem(storageKey);

    if (!value) {
      value = String(Date.now());
      sessionStorage.setItem(storageKey, value);
    }

    return parseInt(value, 10);
  }

  function currentStock() {
    var elapsed = (Date.now() - startedAt()) / 1000;
    var stock = 14;

    for (var i = 0; i < schedule.length; i++) {
      if (elapsed >= schedule[i].after) {
        stock = schedule[i].stock;
      }
    }

    return stock;
  }

  function fillFor(stock) {
    return Math.max(26, Math.min(92, (stock / 14) * 92));
  }

  function renderStock(animate) {
    document.querySelectorAll('[data-mini-cart-stock]').forEach(function(card) {
      var count = card.querySelector('[data-mini-cart-stock-count]');
      var fill = card.querySelector('[data-mini-cart-stock-fill]');
      var stock = currentStock();

      if (count && count.textContent !== String(stock)) {
        if (animate) {
          count.classList.add('is-changing');

          setTimeout(function() {
            count.textContent = String(stock);
            count.classList.remove('is-changing');
          }, 180);
        } else {
          count.textContent = String(stock);
        }
      }

      if (fill) {
        fill.style.width = fillFor(stock) + '%';
      }
    });
  }

  function resetCartHeaderIcon() {
    var cartToggles = document.querySelectorAll(
      '[data-action="toggle-mini-cart"][aria-controls="mini-cart"], .header__cart-toggle[data-action="toggle-mini-cart"]'
    );

    var cartIconStates = document.querySelectorAll(
      '.header__cart-icon.icon-state, .header__action-item--cart .icon-state'
    );

    cartToggles.forEach(function(toggle) {
      toggle.setAttribute('aria-expanded', 'false');
      toggle.classList.remove('is-active');
      toggle.classList.remove('is-expanded');
    });

    cartIconStates.forEach(function(iconState) {
      iconState.setAttribute('aria-expanded', 'false');
      iconState.classList.remove('is-active');
      iconState.classList.remove('is-expanded');
    });
  }

  function closeMiniCartState() {
    var miniCart = document.getElementById('mini-cart');

    if (miniCart) {
      miniCart.setAttribute('aria-hidden', 'true');
      miniCart.classList.remove('is-open');
      miniCart.classList.remove('is-visible');
    }

    resetCartHeaderIcon();

    document.body.classList.remove('mini-cart-is-open');
    document.body.classList.remove('is-mini-cart-open');
  }

  function syncOpenState() {
    var miniCart = document.getElementById('mini-cart');
    var isOpen = !!miniCart && miniCart.getAttribute('aria-hidden') === 'false';

    document.body.classList.toggle('mini-cart-is-open', isOpen);

    if (isOpen) {
      renderStock(true);
    } else {
      resetCartHeaderIcon();
    }
  }

  /*
    Este listener usa capture=true para rodar antes do JS original do tema.
    Assim, ao clicar no X dentro do drawer, ele fecha o carrinho e força
    o ícone do cabeçalho a voltar para o ícone de carrinho.
  */
  document.addEventListener('click', function(event) {
    var closeButton = event.target.closest('#mini-cart .mini-cart__close-button');

    if (!closeButton) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    closeMiniCartState();
  }, true);

  document.addEventListener('DOMContentLoaded', function() {
    renderStock(false);
    syncOpenState();

    var miniCart = document.getElementById('mini-cart');

    if (miniCart && window.MutationObserver) {
      new MutationObserver(syncOpenState).observe(miniCart, {
        attributes: true,
        attributeFilter: ['aria-hidden']
      });
    }

    document.addEventListener('click', function(event) {
      var continueButton = event.target.closest('#mini-cart .mini-cart__continue-button');

      if (!continueButton) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      closeMiniCartState();
    });

    setInterval(function() {
      renderStock(true);
    }, 1000);
  });
})();